import { memo, useState, type JSX } from "react";

import { Dialog } from "@narmi/design_system";
import { modules } from "byzantine";

import NpsScoreQuestion from "./NpsScoreQuestion";
import FreeFormQuestions from "./FreeFormQuestions";

type Props = {
  survey: API.NPS.Survey;
  close: () => void;
};

const SurveyModal = ({ survey, close }: Props) => {
  const npsScoreQuestions = survey.questions.filter(
    (q) => q.answer_type === "npsscore"
  ) as API.NPS.NpsScoreQuestion[];

  const freeFormQuestions = survey.questions.filter(
    (q) => q.answer_type === "freeformtext"
  ) as API.NPS.FreeFormQuestion[];

  const title = modules.nps.useSurveyTitle();

  const [mode, setMode] = useState<API.NPS.SurveyQuestion["answer_type"]>(
    npsScoreQuestions.length ? "npsscore" : "freeformtext"
  );

  const [footer, setFooter] = useState<JSX.Element>();

  return (
    <Dialog isOpen title={title.text} onUserDismiss={close} footer={footer}>
      {mode === "npsscore" && npsScoreQuestions.length ? (
        <NpsScoreQuestion
          question={npsScoreQuestions[0]}
          isFinalQuestion={freeFormQuestions.length === 0}
          setMode={setMode}
          close={close}
          setFooter={setFooter}
        />
      ) : null}
      {mode === "freeformtext" && freeFormQuestions.length ? (
        <FreeFormQuestions
          questions={freeFormQuestions}
          showBackButton={npsScoreQuestions.length > 0}
          setMode={setMode}
          close={close}
          setFooter={setFooter}
        />
      ) : null}
    </Dialog>
  );
};

export default memo(SurveyModal);
